import React, {useState} from 'react';
import toast from 'react-hot-toast';
import {
  useAcceptCandidateMutation,
  useDeclineCandidateMutation,
} from '../../api/employer';
import {expEnum} from '../../utils/constants';

import Modal from '../common/Modal';
import Button from '../ui/Button';
import CandidateDeclineRejectionModal from './CandidateDeclineModal';

const AddCandidateInJobModal = ({
  data,
  declineModal,
  setDeclineModal,
  ...restModalProps
}) => {
  const [currId, setCurrId] = useState({id: '', status: ''});
  const [declineMsg, setDeclineMsg] = useState('');

  const {
    mutate: declineCandidateMutation,
    isLoading: isDeclineCandidateLoading,
  } = useDeclineCandidateMutation();

  const {mutate: acceptCandidateMutation, isLoading: isAcceptCandidateLoading} =
    useAcceptCandidateMutation();

  const declinedCandidate = () => {
    if (declineMsg.trim()) {
      declineCandidateMutation(
        {
          params: {jobId: currId?.id},
          payload: {declinedReason: declineMsg},
        },
        {
          onSuccess: () => restModalProps.onClose(),
        },
      );
    } else {
      toast.error('Please, enter decline reason!');
    }
  };

  const handleAcceptCandidate = (emp) => {
    acceptCandidateMutation(emp._id, {
      onSuccess: () => restModalProps.onClose(),
    });
    setCurrId({id: emp._id, status: 'add'});
  };

  return (
    <Modal {...restModalProps}>
      <div className="flex flex-col space-y-4">
        {data?.length === 0 && <div>No Candidate available.</div>}
        {data?.map((emp) => (
          <div className="py-2" key={emp?._id}>
            <div
              className="flex justify-between bg-gray-200 p-4"
              key={emp?._id}
            >
              <div className="font-semibold">{emp?.employee}</div>
              <div>{expEnum[emp?.totalExp] || emp?.totalExp}</div>
            </div>
            <div className="flex gap-2 pt-5 justify-center">
              <div className="mr-2 basis-[10%]">
                <Button
                  loading={
                    currId.status === 'add' &&
                    emp?._id === currId.id &&
                    isAcceptCandidateLoading
                  }
                  onClick={() => handleAcceptCandidate(emp)}
                >
                  Accept
                </Button>
              </div>
              <div className="ml-2 basis-[10%]">
                <Button
                  className="bg-red-400"
                  loading={
                    currId.status === 'reject' &&
                    emp?._id === currId.id &&
                    isDeclineCandidateLoading
                  }
                  onClick={() => {
                    setDeclineModal(true);
                    setCurrId({id: emp?._id, status: 'reject'});
                  }}
                >
                  Decline
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Decline Modal */}
      {declineModal && (
        <CandidateDeclineRejectionModal
          isOpen={declineModal}
          onClose={() => setDeclineModal(false)}
          text={'decline reason.'}
          type="text"
          value={declineMsg}
          setValue={setDeclineMsg}
          confirm={() => declinedCandidate()}
        />
      )}
    </Modal>
  );
};

export default AddCandidateInJobModal;
